/* globals axios */
import Vue from 'vue';
import Errors from '../classes/errors';

Vue.component('contact-form', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            picked: 'vraag',
            showEancode: false,
            showProductcode: false,
            acceptedValue: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setNewsletterVal(e) {
            const val = e.currentTarget ? e.currentTarget.checked : null;
            console.log('newsletter: ', val);
            this.acceptedValue = val ? 1 : 0;
            // alert(this.value);
        },
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios.post('/', new FormData(form))
            .then((response) => {
                this.submitting = false;
                if (response.data.errors) {
                    this.errors.clear();

                    this.errors.record(response.data.errors);
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();
            })
            .catch((error) => {
                this.submitting = false;
                console.log(error);
            });
        },
    },
});
